<template>
  <b-container class="custom-container p-0 py-5">
    <!-- Shimmer Effect -->
    <b-row class="mt-2" v-if="loading">
      <b-col md="4" sm="4" class="pr-5">
        <card-shimmer
          :imageHead="true"
          :withTitle="true"
          imageHeadHeight="280px"
          v-if="!myJobsMeta.current_page"
        ></card-shimmer>
      </b-col>
      <b-col md="8" sm="8">
        <div class="page-title pt-5 mb-4"></div>
        <b-row>
          <b-col v-for="i in 2" :key="i">
            <card-shimmer
              :imageHead="true"
              :withTitle="true"
              imageHeadHeight="250px"
            ></card-shimmer>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-else>
      <b-col md="4" sm="4" class="pr-5">
        <b-card class="mb-2">
          <b-avatar
            class="mb-3 w-100"
            :src="userAvatar"
            size="280px"
            rounded="lg"
          ></b-avatar>
          <b-card-title class="font-weight-bold">
            <!-- eslint-disable-next-line -->
            {{ userFullname }}
          </b-card-title>
          <hr class="my-4" />
          <b-button
            block
            class="btn-outlined bg-white text-dark"
            variant="outline-secondary"
            :to="{ name: 'user.settings-page', params: { tab: 0 } }"
            >Edit Profile</b-button
          >
        </b-card>
      </b-col>

      <b-col md="8" sm="8">
        <div class="text-center" v-if="myJobs.length === 0">
          <div class="page-title pt-5 mb-4">Oops!</div>
          <div class="font-weight-bold mb-4">
            Looks like you didn’t create any jobs.
            <br />Jobs you create will be displayed here.
          </div>
          <b-button
            class="mb-3"
            variant="primary"
            :to="{ name: 'job.create-job-page' }"
            >Create a Job</b-button
          >
          <b-img
            class="mb-5"
            fluid
            :src="require('@/assets/icons/no-jobs.svg')"
          ></b-img>
        </div>
        <div v-else>
          <div class="page-title pt-5 mb-4">My Jobs</div>
          <job-list :jobs="myJobs" :columns="6" />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import JobList from '@/components/lists/JobList'
import CardShimmer from '@/components/shimmers/card'
import debounce from 'lodash/debounce'

export default {
  components: {
    JobList,
    CardShimmer
  },

  computed: {
    ...mapState({
      myJobs: state => state.job.list,
      myJobsMeta: state => state.job.listMeta,
      user: state => state.auth.user
    }),

    userAvatar() {
      return this.user && this.user.avatar ? this.user.avatar.url : ''
    },

    userFullname() {
      return this.user ? this.user.full_name : ''
    }
  },

  data() {
    return {
      loading: false,
      mainProps: {
        center: true,
        fluidGrow: true,
        blank: true,
        blankColor: '#bbb',
        width: 400,
        height: 280
      }
    }
  },

  methods: {
    ...mapActions({
      getJobs: 'job/getJobs',
      getAuthenticatedUser: 'auth/getAuthenticatedUser'
    }),

    ...mapMutations({
      clearJobs: 'job/clearJobList'
    }),

    handleScroll(e) {
      const docEl = document.documentElement
      if (docEl.scrollTop + window.innerHeight === docEl.scrollHeight) {
        this.loadMoreMyJobs()
      }
    },

    loadMoreMyJobs() {
      if (this.myJobsMeta.current_page < this.myJobsMeta.last_page) {
        this.fetchMyJobs(this.myJobsMeta.current_page + 1)
      }
    },

    async fetchMyJobs(page = 1) {
      if (this.loading) return
      const params = {
        page: page,
        limit: 4,
        author_id: this.user.id
      }
      this.loading = true
      await this.getJobs(params)
      this.loading = false
    }
  },

  async created() {
    this.loading = true
    await this.getAuthenticatedUser()
    this.loading = false

    this.clearJobs()
    this.fetchMyJobs()

    this.handleDebouncedScroll = debounce(this.handleScroll, 100)
    window.addEventListener('scroll', this.handleDebouncedScroll)
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleDebouncedScroll)
  }
}
</script>

<style lang="scss" scoped>
.col-md-4,
.col-sm-4 {
  margin-top: 80px;
}
</style>
